/* eslint-disable */
$ = window.jQuery;
/* eslint-enable */
// CREATE APP

const APP = (window.APP = window.APP || {});

const debug = true;

function consoleLog(logMessage) {
  if (debug) {
    console.log(logMessage);
  }
}

consoleLog("Debug true");

APP.Utilities = (function () {
  const markSup = () => {
    $("body :not(script,sup,iframe)")
      .contents()
      .filter(function () {
        return this.nodeType === 3;
      })
      .replaceWith(function () {
        return this.nodeValue.replace(/[™®†]/g, "<sup>$&</sup>");
      });
  };

  // Improved Text Widow Eliminator using apps/widowadjust.js
  const noWidows = (ele) => {
    consoleLog(ele);
    var carcount = 10;
    $(ele).each(function () {
      // Get the text content of the element
      var text = $(this).text();

      // Check if the last 10 characters contain either '}' or ']'
      var lastTenChars = text.slice(-carcount);
      if (lastTenChars.indexOf("}") !== 0 || lastTenChars.indexOf("]") !== 0) {
        consoleLog("Last 10 characters contain '}' or ']'");
        return;
      } else {
        consoleLog("Last 10 characters do not contain '}' or ']'");
        wt.fix({
          elements: ele,
          chars: carcount,
          method: "nbsp",
          event: "resize",
        });
      }
    });
  };

  const sharePop = () => {
    $("a.share").on("click", function (e) {
      e.preventDefault();
      const $link = $(this);
      const href = $link.attr("href");
      const network = $link.attr("data-network");

      const networks = {
        facebook: { width: 600, height: 300 },
        twitter: { width: 600, height: 254 },
        google: { width: 515, height: 490 },
        linkedin: { width: 600, height: 473 },
      };

      const popup = function (network) {
        const options = "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,";
        window.open(
          href,
          "",
          options +
            "height=" +
            networks[network].height +
            ",width=" +
            networks[network].width
        );
      };

      popup(network);
    });
  };

  const onOpenAccordion = () => {
    $("body").on("shown.bs.collapse", ".post-accordion-list", function (e) {
      // Scroll to the opened accordion item
      const $target = $(e.target);
      if ($target.is(".collapse.show")) {
        setTimeout(function () {
          $(window).trigger("resize");
          window.dispatchEvent(new Event("resize"));
        }, 100);
      }
    });
  };

  const scrollToTab = () => {
    $("body").on("shown.bs.tab", ".nav-pills .button", function (e) {
      // Scroll to the opened tab item

      const $target = $(e.target).data("bs-target");

      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $($target).offset().top - 120,
          },
          1000
        );
      }
    });
  };

  const openAccordion = () => {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1); // Get the hash value without the '#' character
      // Check if there is an element with the matching ID
      if ($("#" + hash).length) {
        // Open the corresponding accordion by triggering a click event on the button
        const $acButton = $("#" + hash);

        if ($acButton) {
          setTimeout(function () {
            $acButton.collapse("show");
          }, 500);
        }
      }

      var target = $("body").find(window.location.hash);
      var targetAccordion = target.parents(".collapse");

      if (targetAccordion) {
        // Show the accordion
        targetAccordion.on("shown.bs.collapse", function () {
          setTimeout(function () {
            var accordionTarget = targetAccordion.find(window.location.hash);
            //Scroll to the accordionTarget after the accordion is fully shown
            $("html, body").animate(
              {
                scrollTop: accordionTarget.offset().top - 0,
              },
              500
            );
          }, 2000);
        });

        // Trigger the accordion to show after a delay
        setTimeout(function () {
          targetAccordion.collapse("show");
        }, 500);
      }
    }
  };

  const matchHeight = (eh) => {
    let elem = $(eh);
    $(elem).css({ height: "auto" });
    let highest = 0,
      thisHeight = 0;

    const setEqHeight = function (elem) {
      highest = 0;
      $(elem).each(function () {
        const $this = $(this);
        thisHeight = $this.outerHeight();

        if (thisHeight > highest) {
          highest = thisHeight;
        }
      });

      $(elem).css({
        height: highest,
      });
      consoleLog("Match Height");
    };
    if ($(elem).length) {
      setEqHeight(elem);
    }
  };

  const dlmWindow = () => {
    $(
      'a[href^="/download/"], a[href$=".pdf"], a.dlm_download_link, a.document, a.download-link'
    ).on("click", function (e) {
      e.preventDefault();

      var downloadUrl = $(this).attr("href");
      window.open(downloadUrl, "_blank");
      return false;
    });
  };

  const dlmEnable = () => {
    $(".search-link").on("click", function (event) {
      var link = $(this);
      setTimeout(function () {
        link.removeAttr("disabled");
      }, 10);
    });
  };

  const firstH2 = () => {
    let $firstH2 = $(".push-content-left > h2.wp-block-heading:first-child");

    if ($firstH2.length) {
      $firstH2.addClass("mt-0");
    }
  };

  const modalFocus = () => {
    $(".modal").on("shown.bs.modal", function () {
      $(this).find(".btn-close").focus();
    });
  };

  const init = function () {
    markSup();
    noWidows("p, h2");
    sharePop();
    onOpenAccordion();
    //scrollToTab();
    //openAccordion();
    dlmWindow();
    firstH2();
    dlmEnable();
    //modalFocus();

    let reszeTimer;
    $(window).on("load resize orientationchange", function (e) {
      clearTimeout(reszeTimer);
      reszeTimer = setTimeout(function () {
        const $resWidth = $(window).innerWidth();
        if ($resWidth >= 992) {
          matchHeight(".match-height");
        }
      }, 500);
    });
    $("body").addClass("ready");
    consoleLog("APP.Utilities");
  };

  return {
    init,
  };
})();

APP.dynamicMenu = (function () {
  let $dynamicMenu, $hasChildren, $close;

  const handleEvents = function () {
    $hasChildren.on("click", function (e) {
      const $this = $(this);
      e.stopPropagation();
      e.preventDefault();

      if ($this.hasClass("open") && $this.hasClass("depth_0")) {
        hideMenus();
      } else if ($this.hasClass("depth_1")) {
        if ($this.hasClass("current-menu")) {
          hideSubMenu($this);
        } else {
          showSubMenu($this);
        }
      } else {
        hideMenus();
        $this.addClass("open current-menu").attr("aria-expanded", true);
        showSubMenu($this);
      }

      $(document).on("click", function (event) {
        if (
          !$(event.target).parents(".dynamic-navigation").find(".nav-link")
            .length
        ) {
          hideMenus();
        }
      });
    });

    $close.on("click", function () {
      const $this = $(this);
      $this.parents(".menu-item").find(".current-menu").focus();
      hideMenus();
    });

    $(window).scroll(function () {
      var scrollPosition = $(window).scrollTop();

      if (scrollPosition > 100) {
        hideMenus();
      }
    });
  };

  var hideSubMenu = function (submenu) {
    submenu
      .attr("aria-expanded", false)
      .removeClass("current-menu")
      .next(".mega-menu")
      .removeClass("open");
    submenu.next(".mega-dropdown-menu").removeClass("open");
    submenu.closest(".mega-dropdown-menu").removeClass("open");
  };

  var hideMenus = function () {
    $dynamicMenu.find(".open").removeClass("open").attr("aria-expanded", false);
    $dynamicMenu.find(".current-menu").removeClass("current-menu");
    $dynamicMenu.find(".mega-dropdown-menu").css({ height: "auto" });
  };

  var showSubMenu = function (submenu) {
    $(".mega-dropdown-menu")
      .removeClass("open")
      .find(".current-menu")
      .removeClass("current-menu");
    submenu
      .attr("aria-expanded", true)
      .addClass("current-menu")
      .next(".mega-menu")
      .addClass("open");
    submenu.next(".mega-dropdown-menu").addClass("open");
    setSubHeight(submenu);
  };

  var setSubHeight = function (submenu) {
    var subHeight = 0;

    subHeight = submenu.next(".mega-dropdown-menu").outerHeight();

    submenu
      .closest(".mega-dropdown-menu.depth_0")
      .css({ height: subHeight })
      .addClass("open");
  };

  const init = function () {
    $dynamicMenu = $(".navigation-container .dynamic-navigation");
    $hasChildren = $dynamicMenu.find(".menu-item-has-children > a");
    $close = $dynamicMenu.find(".close");
    handleEvents();
    console.log("APP.dynamicMenu");
  };

  return {
    init,
  };
})();

APP.offCanvasMenu = (function () {
  let $dynamicMenu, $hasChildren, $close, $back;

  const handleEvents = function () {
    $hasChildren.on("click", function (e) {
      const $this = $(this);
      e.stopPropagation();
      e.preventDefault();

      if ($this.hasClass("open")) {
        $this.removeClass("open").parent().removeClass("open");
        hideSubMenu($this);
      } else {
        if ($this.hasClass("depth_0") & !$this.hasClass("current-menu")) {
          hideAllMenus();
        }
        $this.addClass("open current-menu");
        showSubMenu($this);
      }

      $(document).on("click", function (event) {
        if (
          !$(event.target).parents(".dynamic-navigation").find(".nav-link")
            .length
        ) {
          hideAllMenus();
        }
      });
    });

    $close.on("click", function () {
      const $this = $(this);
      $this.parents(".menu-item").find(".current-menu").focus();
      hideAllMenus();
    });

    $back.on("click", function () {
      const $this = $(this);
      hideParentMenu($this);
      $this
        .parents(".primary-menu")
        .find(".cmap-dropdown-link.open")
        .first()
        .addClass("test")
        .focus();
    });

    $(window).scroll(function () {
      // Get the current scroll position
      var scrollPosition = $(window).scrollTop();

      // Check if the scroll position is greater than 100px
      if (scrollPosition > 100) {
        // Run your script here
        //console.log("User scrolled more than 100px!");
        hideAllMenus();
      }
    });
  };

  var hideSubMenu = function (submenu) {
    submenu
      .attr("aria-expanded", false)
      .next(".cmap-dropdown-menu")
      .removeClass("open");
  };

  var hideParentMenu = function (submenu) {
    submenu
      .parents(".menu-item")
      .first()
      .find(".cmap-dropdown-link")
      .attr("aria-expanded", false)
      .removeClass("open")
      .next(".cmap-dropdown-menu")
      .removeClass("open");
  };

  var hideAllMenus = function () {
    $dynamicMenu.find(".open").removeClass("open").attr("aria-expanded", false);
    $dynamicMenu.find(".current-menu").removeClass("current-menu");
  };

  var showSubMenu = function (submenu) {
    submenu
      .attr("aria-expanded", true)
      .next(".cmap-dropdown-menu")
      .addClass("open")
      .parent()
      .addClass("open");
  };

  const init = function () {
    $dynamicMenu = $(".off-canvas-container .dynamic-navigation");
    $hasChildren = $dynamicMenu.find(".menu-item-has-children > a");
    $close = $dynamicMenu.find(".cmap-dropdown-actions .close");
    $back = $dynamicMenu.find(".cmap-dropdown-actions .back");
    handleEvents();
    console.log("APP.dynamicMenu");
  };

  return {
    init,
  };
})();

APP.MobMenu = (function () {
  let $body, $MobMenuContainer, $MobMenuOpen, $MobMenuText, $mobileClose;

  const MobMenu = function () {
    if (!$MobMenuContainer.length) {
      return;
    }

    $MobMenuOpen.on("click", toggleMobMenu);

    $("body").on("keydown", closeOnEscape);
    function closeOnEscape(event) {
      if (event.keyCode === 27) {
        closeMobMenu();
      }
    }
  };

  var toggleMobMenu = function () {
    if ($MobMenuOpen.attr("aria-expanded") === "true") {
      closeMobMenu();
    } else {
      openMobMenu();
    }
  };

  var openMobMenu = function () {
    $MobMenuContainer.addClass("is-visible").attr("aria-hidden", "false");
    $MobMenuOpen.addClass("open").attr("aria-expanded", "true");
    $body.addClass("mobile-menu-open");
    $MobMenuText.text("CLOSE");
  };

  var closeMobMenu = function () {
    $MobMenuContainer.removeClass("is-visible");
    $MobMenuOpen.removeClass("open").attr("aria-expanded", "false");
    $body.removeClass("mobile-menu-open");
    $MobMenuText.text("MENU");
  };

  $(document).on("click", ".mobile-close", function (event) {
    closeMobMenu();
  });

  let reszeTimer;
  $(window).on("load resize orientationchange", function (e) {
    clearTimeout(reszeTimer);
    reszeTimer = setTimeout(function () {
      const $resWidth = $(window).innerWidth();
      if ($resWidth >= 992) {
        closeMobMenu();
      }
    }, 500);
  });

  const init = function () {
    $body = $("body");
    $MobMenuContainer = $(".off-canvas-container");
    $MobMenuOpen = $(".mobile-menu-open");
    $MobMenuText = $("#menu-text");
    $mobileClose = $(".mobile-close");

    MobMenu();
    consoleLog("APP.MobMenu");
  };

  return {
    init,
  };
})();

APP.Banner = (function () {
  let $cookie, $cookieId, $cookieContent, $acceptCookie, $cookieDays;

  const checkCookie = function (cname) {
    const cookieSet = Cookies.get($cookieId) == "true";
    if (!cookieSet) {
      //alert("not accepted");
      $cookieContent.addClass("active");
    }
  };

  const setAlertCookie = function (cname, cvalue, exdays) {
    Cookies.set($cookieId, "true", {
      expires: $cookieDays,
    });
  };

  const hideCookieBar = function () {
    $cookieContent.removeClass("active");
  };

  const initEvents = function () {
    checkCookie($cookieId);
    $acceptCookie.on("touchstart click", function () {
      setAlertCookie();
      hideCookieBar();
      return false;
    });
  };

  const init = function () {
    $cookie = false;
    $cookieId = "";
    $cookieContent = $("#announcement-banner");
    $acceptCookie = $cookieContent.find("#banner-accept");
    $cookieId =
      $cookieContent.length != ""
        ? $cookieContent.data("id")
        : "AnnouncementCookieAccept";
    $cookieDays = $cookieContent.data("days");
    initEvents();
    consoleLog("APP.Banner");
  };

  return {
    init,
  };
})();

APP.ScrollHeaderFunctions = (function () {
  let $header;
  const scrollFunctions = function () {
    let lastScrollTop = 0;
    const thresh = $header.outerHeight();
    $(window).on("scroll", function (event) {
      const st = $(this).scrollTop();
      if (st > lastScrollTop && lastScrollTop >= thresh) {
        $("body").addClass("headerReady");
        //console.log("down");
      } else if (st < lastScrollTop && lastScrollTop >= thresh) {
        //console.log("up");
        $("body").addClass("headerShow");
      } else if (st < lastScrollTop && st <= 1) {
        $("body").removeClass("headerReady");
        $("body").removeClass("headerShow");
      }
      if (st > lastScrollTop) {
        $("body").removeClass("headerShow");
      }
      lastScrollTop = st;
    });

    $(window).on("load", function () {
      let scroll = "";
      clearTimeout(scroll);
      scroll = setTimeout(function () {
        if ($(this).scrollTop() > 0) {
          //alert($(this).scrollTop());
          $(window).scrollTop($(window).scrollTop() + 2);
        }
      }, 1000);
    });
  };

  const init = function () {
    if (debug) {
      console.log("APP.ScrollHeaderFunctions");
    }
    $header = $(".site-header");
    scrollFunctions();
  };

  return {
    init,
  };
})();

APP.TocMobile = (function () {
  let $tocMobile, $toc;

  const tocCopy = function () {
    if ($toc.length && $tocMobile.length) {
      $toc.clone().appendTo($tocMobile);
    }
    tocEventHandler();
  };

  var tocEventHandler = function () {
    var $tocTitle = $tocMobile.find(".toc-title");
    $("body").on("click", ".toc-title", function () {
      $(".toc-title").toggleClass("active");
      $(".toc-title").next("ul").toggleClass("active");
    });
  };

  const init = function () {
    $tocMobile = $("#tocMobile");
    $toc = $(".table-of-contents");
    tocCopy();
    consoleLog("APP.TocMobile");
  };

  return {
    init,
  };
})();

APP.DivItems = (function () {
  let $divided, $divItem;

  const initDividers = function () {
    let rloTimer;
    $(window).on("resize load orientationchange", function (e) {
      clearTimeout(rloTimer);
      rloTimer = setTimeout(function () {
        clearDividers();
        addDividers();
      }, 200);
    });
  };

  var addDividers = function () {
    $(".divided").each(function () {
      const $divBox = $(this);
      const $divItems = $divBox.find(".div-item");

      const w1 = $divBox.innerWidth(); // Calculate the width of the whole container
      const w2 = $divItems.outerWidth(); // Calculate the width of the items
      const $divIndex = Math.floor(w1 / w2); // Calculate how many items fit per row

      //console.log($divIndex);

      $divItems.each(function (index) {
        if ((index + 1) % $divIndex !== 0 && index + 1 !== $divItems.length) {
          // Insert dividers for all items except the last one on each row
          $(this).after('<div class="post-divider"></div>');
        }
      });
    });
  };

  var clearDividers = function () {
    $(".post-divider").remove();
  };

  const init = function () {
    $divided = $(".divided");
    initDividers();
  };

  return {
    init,
  };
})();

APP.Footnotes = (function () {
  let $pageContent, $pageSlug, $storyMap;
  let footnotesInitialized = false;

  const footnotes = function () {
    var siteURL = window.location.origin;
    if ($pageContent && $pageContent.length) {
      var elementHtml = $pageContent.html();

      // Regular expression to find text within double curly braces (including HTML tags)
      var regex = /{{([^}]*)}}/g;

      var matches = elementHtml.match(regex);

      // Iterate through the matches and replace each one with an index
      if (matches) {
        //console.log(matches);
        matches.forEach(function (match, index) {
          // Replace the item with an index
          consoleLog("Footnote Found");
          var replacedText =
            '<a id="fn-' +
            (index + 1) + // Increment index by 1
            '" href="' +
            siteURL +
            "/regional-plan/resources/endnotes/#fn-" +
            $pageSlug +
            "-" +
            (index + 1) + // Increment index by 1
            '" class="footnote-link"><strong><span data-fn="footnote">(' +
            (index + 1) + // Increment index by 1
            ")</span></strong></a>";

          $pageContent.html(function (i, html) {
            return html.replace(match, replacedText);
          });
        });
      }
    } else {
      consoleLog("Required footnote content not found.");
    }
    $("sup a").each(function () {
      let sup = $(this).parent();
      let prevTextNode = sup[0].previousSibling;

      if (prevTextNode && prevTextNode.nodeType === 3) {
        let text = prevTextNode.nodeValue;
        let lastSpaceIndex = text.lastIndexOf(" ");

        if (lastSpaceIndex !== -1 && lastSpaceIndex < text.length - 1) {
          let textBeforeLastSpace = text.slice(0, lastSpaceIndex);
          let textAfterLastSpace = text.slice(lastSpaceIndex);

          if (textBeforeLastSpace.trim().length > 0) {
            prevTextNode.nodeValue = textBeforeLastSpace;

            let span = $('<span class="nobreak">').text(textAfterLastSpace);
            sup.before(span);
            span.append(sup);

            span.after(document.createTextNode(" "));
          }
        }
      }
    });
  };

  const init = function () {
    $pageContent = $(".site-content article").not(".push-content-right");
    $pageSlug = $("body").data("slug");
    $storyMap = $(".storymaplayout");
    if ($(".storymaplayout").length > 0) {
      // If .storymaplayout exists, bind to storymapsInitialized event
      $(document).on("storymapsInitialized", function () {
        if (!footnotesInitialized) {
          footnotes();
          footnotesInitialized = true; // Set flag to true after initialization
        }
      });
    } else {
      // If .storymaplayout does not exist, call footnotes() directly
      if (!footnotesInitialized) {
        footnotes();
        footnotesInitialized = true; // Set flag to true after initialization
      }
    }
    consoleLog("APP.Footnotes");
  };

  return {
    init,
  };
})();

APP.Share = (function () {
  let $share, $field, $input, $copy, $copied, $currentURL;

  const initEvents = function () {
    $field = $share.find(".field");
    $input = $field.find("input[type='text']");
    $copy = $field.find("button.copy");
    $copied = $field.find("button.copied");
    $currentURL = window.location.href;
    $input.val($currentURL);

    $copy.on("click", function () {
      $currentURL = window.location.href;
      $input.select();

      navigator.clipboard
        .writeText($currentURL)
        .then(function () {
          $field.addClass("active");
          $copy.text("Copied");
          $copied.attr("aria-hidden", false).focus();
          alert($currentURL + " has been copied to the clipboard");

          setTimeout(() => {
            window.getSelection().removeAllRanges(); // Remove selection from page
            $field.removeClass("active");
            $copy.text("Copy").focus();
            $copied.attr("aria-hidden", true);
          }, 3000);
        })
        .catch(function (err) {
          console.error("Failed to copy field text to the clipboard", err);
        });
    });
  };

  const init = function () {
    $share = $(".share-popup");
    $share.on("shown.bs.modal", initEvents());
    consoleLog("APP.Share");
  };

  return {
    init,
  };
})();

APP.ScrollTo = (function () {
  var $offset;

  const loadscroll = function () {
    if (window.location.hash && window.location.hash !== "#") {
      const selector = window.location.hash;

      waitForEl(
        selector,
        function () {
          scrollToAnchor(selector, function () {
            openElements(selector);
          });
        },
        3000
      );
    }
  };

  var waitForEl = function (selector, callback, maxTimes = false) {
    if ($(selector).length) {
      callback();
    } else {
      if (maxTimes === false || maxTimes > 0) {
        maxTimes != false && maxTimes--;
        setTimeout(function () {
          waitForEl(selector, callback, maxTimes);
        }, 3000);
      }
    }
  };

  const samescroll = function () {
    $('a[href^="#"]').each(function (e) {
      e.preventDefault;
      let $this = $(this);

      $this.on("click", function (e) {
        e.preventDefault;
        var selector = $this.attr("href");
        if (selector !== "#") {
          waitForEl(
            selector,
            function () {
              scrollToAnchor(selector, function () {
                openElements(selector);
              });
            },
            3000
          );
        }
      });
    });
  };

  var getHeaderHeight = function () {
    return new Promise((resolve) => {
      var scrollOffset = "";
      var siteHeaderHeight = $(".site-header").outerHeight();
      var primaryNavWrapperHeight = $(".primary-nav-wrapper").outerHeight();
      var tocMobileHeight = 0;
      if ($(".toc-mobile").length) {
        tocMobileHeight = $(".toc-mobile").outerHeight();
      }

      scrollOffset =
        siteHeaderHeight + primaryNavWrapperHeight + tocMobileHeight + $offset;

      resolve(scrollOffset);
    });
  };

  var openElements = function (selector) {
    var targetType = $(selector).attr("data-bs-toggle");

    if (targetType === "collapse") {
      consoleLog("collapse");
      $(".collapse").collapse("hide");
      var $targetCollapseId = $(selector).attr("data-bs-target");
      $($targetCollapseId).collapse("show");
    } else if (targetType === "pill") {
      consoleLog("tab");
      $(selector).tab("show");
    }
  };

  const scrollToAnchor = function (anchor, callback) {
    getHeaderHeight().then((headerOffSet) => {
      let $sct = "";
      if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        $sct = "body,html";
      } else {
        $sct = "html";
      }
      $($sct).scrollTop(0);

      var offsetTop = $(anchor).offset().top - headerOffSet;
      setTimeout(function () {
        $($sct).scrollTop(offsetTop);
        if (typeof callback === "function") {
          callback();
        }
      }, 2000);
    });
  };

  const init = function () {
    $offset = 20;
    consoleLog("APP.ScrollTo");
    loadscroll();
    samescroll();
  };

  return {
    init,
  };
})();

APP.Carousel = (function () {
  let $postsCarousel;
  const bootstrap = "";
  const setCarousel = function () {
    if (
      typeof bootstrap !== "undefined" &&
      typeof bootstrap.Carousel === "function"
    ) {
      // The bootstrap.Carousel function exists
      const carousel = new bootstrap.Carousel($postsCarousel, {
        interval: 1000000,
      });
    }

    $("#posts-carousel .carousel-item").first().addClass("active");
  };

  const carouselItemHeight = function () {
    let items = $("#posts-carousel .carousel-item"), // grab all the slides
      heights = [], // array to store heights
      tallest; // tallest slide

    if (items.length) {
      normalizeHeights();
    }

    function normalizeHeights() {
      items.each(function () {
        heights.push($(this).innerHeight()); // add each slide's height
      }); // to the array

      tallest = Math.max.apply(null, heights); // find the largest height

      items.each(function () {
        $(this).css({
          "min-height": tallest + "px",
        }); // set each slide's minimum
      }); // height to the largest
    }

    $(window).on("resize orientationchange", function () {
      (tallest = 0), (heights.length = 0); // reset the variables

      items.each(function () {
        $(this).css("min-height", "0"); // reset each slide's height
      });

      normalizeHeights(); // run it again
    });
  };
  const init = function () {
    console.log("APP.Carousel");
    $postsCarousel = $("#posts-carousel");
    setCarousel();
    //carouselItemHeight();
  };

  return {
    init,
  };
})();

APP.PostCarousel = (function () {
  var $cta_Carousel, $carWrap, $carItems, $itemLength;

  var setCarousel = function () {
    $cta_Carousel
      .on("changed.owl.carousel initialized.owl.carousel", function (event) {
        $(event.target)
          .find(".owl-item")
          .removeClass("prev")
          .eq(event.item.index - 1)
          .addClass("prev");
        $(event.target)
          .find(".owl-item")
          .removeClass("next")
          .eq(event.item.index + 1)
          .addClass("next");
      })
      .on("initialized.owl.carousel", function (event) {
        setTimeout(function () {
          setHeight();
        }, 500);
      })
      .owlCarousel({
        dots: true,
        navigation: false,
        autoWidth: false,
        loop: false,
        nav: false,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i>',
        ],
        margin: 0,
        autoplay: false,
        responsiveBaseElement: ".items-wrapper",
        autoplayTimeout: 8500,
        smartSpeed: 500,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          899: {
            items: 4,
          },
        },
        onInitialized: checkNavigation, // Call function on carousel initialization
        onResized: checkNavigation,
      });
    setNav();
    setDots();
  };

  var checkNavigation = function (event) {
    var itemCount = event.item.count; // Get the total number of items in the carousel
    var visibleItems = event.page.size; // Get the number of visible items in the carousel
    var isNavVisible = itemCount > visibleItems; // Check if navigation should be visible
    var isDotsVisible = itemCount > visibleItems;

    $(".owl-nav").toggle(isNavVisible); // Toggle navigation visibility based on condition
    $(".owl-dots").toggle(isDotsVisible);
  };

  var setHeight = function () {
    //var $carItems = $(".owl-item");
    var $highest = 0;
    $carItems.each(function () {
      $(this).css({
        "min-height": "0",
      });
      var $thisHeight = $(this).outerHeight();

      if ($thisHeight > $highest) {
        $highest = $thisHeight;
      }
    });

    $carItems.css({
      height: $highest,
    });
  };

  var setNav = function () {
    var $carNav = $(".owl-nav");
    $carNav.prependTo($carWrap);
  };

  var setDots = function () {
    $cta_Carousel.each(function () {
      $(this)
        .find(".owl-dot")
        .each(function (index) {
          $(this).attr("aria-label", "Slide " + (index + 1));
        });
    });
  };

  var init = function () {
    $cta_Carousel = $(".carousel-wrapper .owl-carousel");
    $carWrap = $(".items-outer");
    $carItems = $(".owl-item");
    $itemLength = $carItems.length;
    //setCarousel();
    if ($cta_Carousel.length) {
      setCarousel();
    }
    var ehwTimer;
    $(window).on("load resize orientationchange", function (e) {
      clearTimeout(ehwTimer);
      ehwTimer = setTimeout(function () {
        if ($cta_Carousel.length > 0) {
          setCarousel();
        }
      }, 500);
    });
  };

  return {
    init: init,
  };
})();

APP.PostModal = (function () {
  const currentURL = window.location.href;
  const apiUrl = currentURL.startsWith("http://localhost:8888/")
    ? "/Astriata/CMAP/wp-json/wp/v2/"
    : "/wp-json/wp/v2/";
  let $modalPosts, $modalPost;

  const initEvents = function () {
    $modalPosts.find(".modal").appendTo("body");
    $modalPost.on("click", handlePostClick);
  };

  const handlePostClick = function () {
    const $this = $(this);
    const postId = $this.data("post-id");
    const postType = $this.data("post-type");
    const $modalTarget = $this.data("modal-target");

    getPost(postId, postType, $modalTarget)
      .then(function () {
        console.log("All processes are completed.");
        openPostModal($modalTarget);
      })
      .catch(function (error) {
        console.error("An error occurred:", error);
      });
  };

  var getPost = function (postId, postType, modalTarget) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: apiUrl + postType + "/" + postId,
        type: "GET",
        success(post) {
          console.log("Retrieved post:", post);
          const { title, content, ACF, featured_media } = post;
          const postTitle = title.rendered;
          const postContent = content.rendered;
          const acfData = ACF ? ACF : "";

          console.log("ACF Data:", acfData);

          if (featured_media !== 0) {
            getImage(featured_media)
              .then(function (imageData) {
                console.log(imageData);
                const { alt_text, media_details, source_url } = imageData;
                const alText = alt_text || title.rendered;

                const modalImage = `<img src="${
                  media_details.sizes.medium
                    ? media_details.sizes.medium.source_url
                    : source_url
                }" alt="${alText}">`;

                let modalContent = `<h2 class="modal-title">${postTitle}</h2>`;

                // Check if "board_&_committees" exists in ACF data
                if (acfData["board_&_committees"]) {
                  // Check if "representing" exists and append it
                  if (acfData["board_&_committees"]["representing"]) {
                    const representing =
                      acfData["board_&_committees"]["representing"];
                    modalContent += `<div class="representing">${representing}</div>`;
                  }

                  // Check if "position" exists and append it
                  if (acfData["board_&_committees"]["position"]) {
                    const position = acfData["board_&_committees"]["position"];
                    modalContent += `<div class="position">${position}</div>`;
                  }
                }

                // Append the post content div
                modalContent += `<div class="post-content">${postContent}</div>`;

                $(modalTarget).find(".modal-body .post-image").html(modalImage);
                $(modalTarget).find(".modal-body .content").html(modalContent);
                resolve();
              })
              .catch(function (error) {
                reject(error);
              });
          } else {
            const modalContent = `<h2 class="modal-title">${postTitle}</h2><div class="post-content">${postContent}</div>`;
            $(modalTarget).find(".modal-body .post-image").html("");
            $(modalTarget).find(".modal-body .content").html(modalContent);
            resolve();
          }
        },
        error(jqXHR, textStatus, errorThrown) {
          console.error("Failed to retrieve post:", errorThrown);
          reject(errorThrown);
        },
      });
    });
  };

  var getImage = function (imageId) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: apiUrl + "media/" + imageId,
        type: "GET",
        success(imagedata) {
          console.log("Retrieved image:", imagedata);
          resolve(imagedata);
        },
        error(jqXHR, textStatus, errorThrown) {
          console.error("Failed to retrieve image:", errorThrown);
          reject(errorThrown);
        },
      });
    });
  };

  var openPostModal = function (target) {
    //alert(target);
    $(target).modal("show");
  };

  const init = function () {
    $modalPosts = $(".modal-posts-wrapper");
    $modalPost = $("[data-modal-target]");
    initEvents();
    console.log("APP.PostModal"); // Assuming you want console.log here
  };

  return {
    init,
  };
})();

APP.GlossarySearch = (function () {
  var delayTimer, $searchInput, $glossaryResults;

  const setGlossary = function () {
    /* eslint-disable */
    // eslint disabled because ajax_object is declared in an external PHP file.

    // Initial request to fetch all glossary posts
    $.ajax({
      type: "POST",
      url: ajax_object.ajax_url,
      data: {
        action: "custom_glossary_search_action",
        glossary_search_value: "", // Empty search value to fetch all glossary posts
      },
      success: function (response) {
        $glossaryResults.html(response);
      },
    });

    // Event listener for input on search input field
    if ($searchInput.length) {
      $searchInput.on("input", function () {
        clearTimeout(delayTimer);
        var searchValue = $(this).val();
        delayTimer = setTimeout(function () {
          $.ajax({
            type: "POST",
            url: ajax_object.ajax_url,
            data: {
              action: "custom_glossary_search_action",
              glossary_search_value: searchValue, // Use correct parameter name
            },
            success: function (response) {
              $glossaryResults.html(response);
            },
          });
        }, 100); // Adjust the delay as needed (in milliseconds)
      });
    }
    /* eslint-enable */
  };

  const init = function () {
    $searchInput = $("#glossary_search-input");
    $glossaryResults = $("#glossary-results");
    setGlossary();
    console.log("APP.GlossarySearch initialized"); // Corrected console.log call
  };

  return {
    init,
  };
})();

APP.ToolTip = (function () {
  var $toolTip;

  const glossaryEvents = function () {
    $toolTip.each(function () {
      var $tip = $(this);
      var $close = $tip.find(".term-close");
      $tip.on("mouseover touchstart", function (e) {
        e.stopPropagation();
        hideTip();
        $tip.addClass("active");
      });
      $close.on("click", function (e) {
        e.stopPropagation();
        hideTip();
      });
    });
  };

  const hideTip = function () {
    if ($toolTip && $toolTip.length) {
      $toolTip.removeClass("active");
    }
  };

  $(document).on("click", function (event) {
    if (!$(event.target).parent(".term-definition-container").length) {
      hideTip();
    }
  });

  const init = function () {
    $toolTip = $(".glossary-term");
    glossaryEvents();
    consoleLog("APP.ToolTip");
  };

  return {
    init,
  };
})();

APP.Layout = (function () {
  var $mode, $group;

  var initEvents = function () {
    $mode.on("click", function () {
      var $layout = $(this).data("mode");
      $mode.removeClass("active");
      $(this).addClass("active");
      $group.attr("data-layout", $layout);
    });
  };

  var init = function () {
    consoleLog("APP.Layout");
    $mode = $(".layout-mode a");
    $group = $(".news-posts-wrapper .news-posts");
    initEvents();
  };

  return {
    init: init,
  };
})();

APP.Hotspots = (function () {
  var $hotspots, $hotspot;

  var handleEvents = function () {
    if ($hotspots.length) {
      $hotspot.each(function () {
        var $this = $(this);
        $this.on("click", function () {
          if ($this.hasClass("active")) {
            $this.removeClass("active");
          } else {
            $hotspot.removeClass("active");
            $this.addClass("active");
          }
        });
      });
    }
  };

  const init = function () {
    $hotspots = $(".hotspot-image-wrapper");
    $hotspot = $hotspots.find(".hotspot");
    handleEvents();
    consoleLog("APP.Hotspots");
  };

  return {
    init,
  };
})();

APP.Iframe = (function () {
  var $iframeWrapper, $iframe;

  var setIframe = function () {
    if ($iframeWrapper.length) {
      $iframeWrapper.each(function () {
        var $this = $(this);
        var $iframeBlock = $this.find(".iframe-block");
        var $iframe = $iframeBlock.find("iframe");
        var iframeWidth = $iframe.attr("width");
        if (iframeWidth.includes("px")) {
          iframeWidth = iframeWidth.replace("px", "");
        }
        if (iframeWidth.includes("%")) {
          iframeWidth = "";
        }
        var iframeHeight = $iframe.attr("height");
        if (iframeHeight.includes("px")) {
          iframeHeight = iframeHeight.replace("px", "");
        }
        if (iframeHeight.includes("%")) {
          iframeHeight = "";
        }
        var iframeSrc = $iframe.attr("src");
        var $fullWin = $this.find(".iframe-header .full-window a");
        $fullWin.attr("href", iframeSrc);

        if (iframeWidth && iframeHeight) {
          //var aspectRatio = (iframeHeight / iframeWidth) * 100;
          $iframeBlock
            .addClass("aspect-ratio")
            .css({ "aspect-ratio": iframeWidth / iframeHeight });
        } else {
          console.log(
            "Width and/or Height attributes are missing for the iframe."
          );
        }
      });
    }
  };

  const init = function () {
    $iframeWrapper = $(".iframe-block-wrapper");
    setIframe();
    consoleLog("APP.Iframe");
  };

  return {
    init,
  };
})();

APP.ExtLinks = (function () {
  var extLinks = function () {
    var disallowedDomains = [
      "cmap.illinois.gov",
      "cmapdev.wpenginepowered.com",
      "cmapstg.wpenginepowered.com",
      "cmapdev.local",
      "localhost",
      "cmapstageilli.com",
    ];

    $("a").each(function () {
      var href = $(this).attr("href");
      if (href && (href.startsWith("http://") || href.startsWith("https://"))) {
        var isAllowed = true;
        for (var i = 0; i < disallowedDomains.length; i++) {
          if (href.indexOf(disallowedDomains[i]) !== -1) {
            isAllowed = false;
            break;
          }
        }
        if (isAllowed) {
          $(this).attr("target", "_blank");
        }
      }
    });
  };

  const init = function () {
    extLinks();
    consoleLog("APP.ExtLinks");
  };

  return {
    init,
  };
})();

APP.signUpModal = (function () {
  var signUp = function () {
    $("a.signup").on("click", function () {
      var scriptId = $(this).data("signup-id");
      //alert($(this).data("signup-id"));
      if (!document.getElementById(scriptId)) {
        var script = document.createElement("script");
        script.src = "https://public.govdelivery.com/assets/Signup.js";
        script.dataset.accountCode = "ILCMAP";
        script.dataset.signupId = scriptId;
        script.id = scriptId;
        $("#signupContent").html("");
        document.getElementById("signupContent").appendChild(script);
      }
    });
  };

  const init = function () {
    signUp();
    consoleLog("APP.SignUpModal");
  };

  return {
    init,
  };
})();

APP.Form = (function () {
  var $form;

  var actionEvents = function () {
    document.addEventListener(
      "wpcf7invalid",
      function (event) {
        setTimeout(function () {
          $("input.wpcf7-not-valid").first().focus();
        }, 2000);
      },
      false
    );
  };

  var init = function () {
    $form = $(".wpcf7-form");
    actionEvents();
  };

  return {
    init: init,
  };
})();

APP.ActiveLink = (function () {
  var $currentUrl, $link;

  var setLinks = function () {
    $link.each(function () {
      if ($currentUrl.includes($(this).attr("href"))) {
        $(this).addClass("active").attr("aria-current", "page");
      }
    });
  };

  var init = function () {
    $currentUrl = window.location.href;
    $link = $("a href");
    setLinks();
  };

  return {
    init: init,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  APP.Utilities.init();
  APP.dynamicMenu.init();
  APP.offCanvasMenu.init();
  APP.MobMenu.init();
  APP.ScrollHeaderFunctions.init();
  APP.PostCarousel.init();
  APP.TocMobile.init();
  APP.DivItems.init();
  APP.Share.init();
  APP.PostModal.init();
  APP.GlossarySearch.init();
  APP.Layout.init();
  APP.Footnotes.init();
  APP.Iframe.init();
  APP.ToolTip.init();
  APP.Hotspots.init();
  APP.Banner.init();
  APP.ScrollTo.init();
  APP.ExtLinks.init();
  APP.signUpModal.init();
  APP.Form.init();
  //APP.ActiveLink.init();
});
